import { ApiData } from "@cawita/core-front/api";
import { CwtModel } from "../modules/crud";
import { Event } from "./event.model";
import { User } from "./user.model";

export enum ReservationType {
    User = 'user',
    Filled = 'filled',
    Auto = 'auto'
}

export class ReservationExternalAttendee {
    firstName: string;
    lastName: string;
    login?: string;
}

@CwtModel({ name: 'reservation', path: '/reservation' })
export class EventReservation extends ApiData {
    user: User;
    event: Event;
    type: ReservationType;
    externalAttendees?: ReservationExternalAttendee[];
    doesUserAttend?: boolean;

    public get firstAttendee() { return this.externalAttendees[0]; }

    constructor(json: any) {
        super(json);
        if (this.externalAttendees?.length) {
            this.externalAttendees = this.externalAttendees.map(e => ({
                ...e,
                login: [e.firstName, e.lastName].filter(e => e?.length).join(' ')
            }));
        }
    }
}